module.exports = __webpack_public_path__ + "static/media/sound_5.403b1c84.mp3";